'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationResponse', ['$scope', '$stateParams',
        function ($scope, $stateParams) {
            $scope.response = $stateParams.response;
            $scope.responseID = $stateParams.responseID;
            $scope.fireStartTrigger = $stateParams.fireStartTrigger;
    }])
;